import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Fragment } from 'react';
import Helmet from '../_virtual/Helmet.js';
import map from '../node_modules/ramda/es/map.js';
import curry from '../node_modules/ramda/es/curry.js';
import PropTypes from 'prop-types';

var withPageMetaData = curry(function (_ref, Component, props) {
  var _ref$meta = _ref.meta,
    meta = _ref$meta === void 0 ? [] : _ref$meta,
    title = _ref.title;
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Helmet, null, title && /*#__PURE__*/React__default.createElement("title", null, title), map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    return /*#__PURE__*/React__default.createElement("meta", {
      name: key,
      content: value,
      key: key
    });
  }, meta)), /*#__PURE__*/React__default.createElement(Component, props));
});
withPageMetaData.displayName = "WithPageMetadata";
withPageMetaData.propTypes = {
  options: PropTypes.shape({
    title: PropTypes.string,
    meta: PropTypes.arrayOf(PropTypes.array)
  }),
  Component: PropTypes.element
};
var withPageMetadata = withPageMetaData;
var metadata = function metadata(title) {
  return {
    title: "".concat(title, " | PGA.org"),
    meta: [["description", "PGA.org"]]
  };
};

export { metadata, withPageMetadata };
